export default class AggregatorType {
  static get DeliveryClub () { return 'deliveryСlub' } // деливери клаб
  static get Yandex () { return 'yandex' } // яндекекс еда

  static get SberMarket () { return 'sber_market' }
  static get Chibis () { return 'chibis' }

  static getAll () {
    return [
      AggregatorType.Yandex,
      AggregatorType.DeliveryClub,
      AggregatorType.SberMarket,
      AggregatorType.Chibis,
    ]
  }

  static getName (enumValue) {
    switch (enumValue) {
      case AggregatorType.Yandex:
        return 'Яндекс.Еда'
      case AggregatorType.DeliveryClub:
        return 'Delivery Club'
      case AggregatorType.SberMarket:
        return 'Купер'
      case AggregatorType.Chibis:
        return 'Чибис'
      default:
        return enumValue
    }
  }

  static getAllVariants () {
      return this.getAll().map(item => ({
        value: item,
        name: this.getName(item),
      }))
    }
}
